import { render, staticRenderFns } from "./pcDecorateSelect.vue?vue&type=template&id=11901582&scoped=true&"
import script from "./pcDecorateSelect.vue?vue&type=script&lang=ts&"
export * from "./pcDecorateSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11901582",
  null
  
)

export default component.exports